import {del, get, post, put} from '@/services/api'
import {cloneDeep} from "lodash";


const state = {
    scenario: null,
    scenarios: [],
    newScenario: {
        id: null,
        localizedAttributes: {
            cz: {
                name: "",
                description: ""
            },
            en: {
                name: "",
                description: ""
            }
        },
        locations: {},
    },
    emptyScenario: {
        id: null,
        localizedAttributes: {
            cz: {
                name: "",
                description: ""
            },
            en: {
                name: "",
                description: ""
            }
        },
        locations: {},
    },
    didLoadScenario: false,
    didLoadScenarios: false,
    scenarioHeaders: [
        {
            title: 'Název prohlídky',
            align: 'start',
            sortable: true,
            key: 'name',
            width: "35%",
            filterable: true
        },
        {
            title: 'Popis prohlídky',
            align: 'start',
            sortable: true,
            key: 'description',
            width: "45%",
            filterable: true
        },
        {
            title: 'Počet lokací',
            align: 'start',
            sortable: true,
            key: 'amount',
            width: "20%",
            filterable: true
        },
    ],
    scenarioImages: [],
};

const getters = {
    scenarios: state => state.scenarios,
    scenarioById: state => id => {
        return state.scenarios.find(s => s.id === id)
    },
    didLoadScenario: state => state.didLoadScenario,
    didLoadScenarios: state => state.didLoadScenarios,
    getScenario: state => state.scenario,
    newScenario: state => state.newScenario,
    emptyScenario: state => state.emptyScenario,
    getScenarioHeaders: state => state.scenarioHeaders,
    getScenarioImages: state => state.scenarioImages,
};

const actions = {
    async fetchScenarios({commit}) {
        commit('setDidLoadScenarios', false);
        await get('onboarding/scenarios/').then((response) => {
            commit('setScenarios', response.data.items);
            commit('setDidLoadScenarios', true);
        })

    },

    async fetchScenarioById({commit}, id) {
        commit('errors/clear', null, { root: true });
        commit('setDidLoadScenario', false);
        await Promise.all([
            get(`onboarding/scenarios/${id}`),
            get(`onboarding/scenarios/images/${id}`),
        ]).then((response) => {
            commit('setScenario', response[0].data.content);
            commit('setImages', response[1].data.items);
            commit('setDidLoadScenario', true);
        }).catch(e => {
            if (e.statusCode === 404) {
                commit('errors/objectNotFound', null, {root: true});
            } else {
                throw e;
            }
        })
    },
    async fetchImages({commit}, id) {
        try {
            const response = await get(`onboarding/scenarios/images/${id}`)
            commit('setImages',response.data.items)
        } catch (e) {
            console.error(e);
        }
    },

    async createScenario({commit}, {scenario}) {
        const response = await post(`onboarding/scenarios/`, scenario);
        const newScenario = response.data.content;
        commit('addScenario', newScenario);
        return newScenario.id;
    },

    async updateScenario({commit}, {scenario}) {
        const response = await put(`onboarding/scenarios/${scenario.id}`, scenario);
        commit('updateScenario', response.data.content);
    },
    async deleteScenario({ commit },  id) {
        await del( `onboarding/scenarios/${id}`)
            .then(() => {
                commit('updateScenarios', {id});
            });
    },
    clearScenario({commit}){
        commit('clearNewScenario', cloneDeep(state.emptyScenario))
    }
};

const mutations = {
    setScenario: (state, scenario) => (state.scenario = scenario),
    clearNewScenario: (state, value)=>(state.newScenario = {...value}),
    setScenarios: (state, scenarios) => (state.scenarios = scenarios),
    updateScenario: (state, item) => {
        const existing = state.scenarios.findIndex(s => s.id === item.id);
        if (existing > -1) {
            state.scenarios.splice(existing, 1, item);
        } else {
            state.scenarios.push(item);
        }
    },
    addScenario: (state, item) => (state.scenarios.push(item)),
    setDidLoadScenario: (state, value) => state.didLoadScenario = value,
    setDidLoadScenarios: (state,value) => state.didLoadScenarios = value,
    updateScenarios: (state, {id}) => {
        let scenarios = [];
        state.scenarios.forEach( (item) => {
            if ( item.id !== id ){
                scenarios.push(item);
            }
        });
        state.scenarios = scenarios;
    },
    addImage: (state, image) => (state.scenarioImages.push(image)),
    setImages: (state, images) => (state.scenarioImages = images),
    removeImage: (state, id) => state.scenarioImages = state.scenarioImages.filter(i => i.id !== id),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
